UC.views.EnterpriseRequests = Backbone.View.extend({
  initialize: function() {
    UC.utils.initTransparentNav('#nav');
  }
});
